import { Module } from 'wrapper6'

const $ = jQuery

export default class Sticky extends Module {
  ready (app) {
    this.apply_stickies()

    window.addEventListener('scroll', () => {
      this.apply_stickies()
    })
  }

  apply_stickies () {
    const _$stickies = [].slice.call(document.querySelectorAll('.sticky'))
    _$stickies.forEach((_$sticky) => {
      if (CSS.supports && CSS.supports('position', 'sticky')) {
        this.apply_sticky_class(_$sticky)
      }
    })
  }

  apply_sticky_class (_$sticky) {
    const currentOffset = _$sticky.getBoundingClientRect().top
    const stickyOffset = parseInt(getComputedStyle(_$sticky).top.replace('px', ''))
    const isStuck = currentOffset <= stickyOffset

    _$sticky.classList.toggle('is-sticky', isStuck)
    document.querySelector('header').classList.toggle('has-sticky', isStuck)
  }
}
